export default __webpack_public_path__ + "static/media/useguide2.a67bbf94.png";